import { render, staticRenderFns } from "./OrderProductStock.vue?vue&type=template&id=7d13d752&scoped=true&"
import script from "./OrderProductStock.vue?vue&type=script&lang=js&"
export * from "./OrderProductStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d13d752",
  null
  
)

export default component.exports